// extracted by mini-css-extract-plugin
module.exports = {"delete-container":"style_delete-container__3mAd4","delete":"style_delete__2vwEX"};